/** Monta um link "clique para enviar" do WhatsApp (wa.me) — gratuito, sem
 * integração de API, mas exige que o gestor clique em "enviar" manualmente
 * para cada pessoa (não é disparo automático). */
export function waLink(telefone: string, mensagem: string): string {
  const digits = String(telefone || '').replace(/\D/g, '');
  const comDDI = digits.startsWith('55') ? digits : `55${digits}`;
  return `https://wa.me/${comDDI}?text=${encodeURIComponent(mensagem)}`;
}
